var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import qs from 'qs';
import cx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import HeaderLogo from './Logo';
import { MobileHeader } from './Mobile';
import { DesktopHeader } from './Desktop';
import { ProPromoBanner, UpdatePaymentBanner } from './Banner';
import { ClientNames } from '../../models';
import { Links } from '../../components/links';
import { InitIntl, ReactIntl } from '../../helpers/intel';
import { useStyles } from './style';
const gtmClicked = (action, clientName) => {
    let page;
    if (clientName == ClientNames.designs_ai) {
        page = window.location.pathname
            .split('?')[0]
            .split('/')
            .reverse()[0]
            .toLowerCase()
            .replace(/\s/g, '_');
    }
    const id = clientName.trim().toLowerCase().replace(/\s/g, '_');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'btnClick',
        btnLabel: `${action}-${page || 'Index'}-${id}`
    });
};
export const Header = ({ Link, user, isLogin, isLoading, currentLanguage, changeLang = () => { }, currentRoute = '', clientName, clientId, redirectPath, router, additionalMenu = [], styles, customHeaderStyle = {}, customLinkStyle = {}, isLocal, proPlanId, accountCreatedDate = null, onClickBanner = () => { }, onAction }) => {
    var _a, _b, _c, _d, _e;
    if (!onAction) {
        onAction = ({ action }) => {
            gtmClicked(action, clientName);
            const pathname = `/user/${action === 'signup'
                ? 'sign-up'
                : action === 'login'
                    ? 'sign-in'
                    : 'sign-out'}`;
            const query = {};
            if (clientId)
                query.c = clientId;
            if (redirectPath)
                query.r = redirectPath;
            if (clientName === ClientNames.designs_ai && router) {
                router.push({ pathname, query });
            }
            else {
                window.location.href = `${isLocal ? 'https://dev.designs.ai' : ''}${pathname}?${qs.stringify(query)}`;
            }
        };
    }
    const classes = useStyles(styles);
    const [intl, setIntl] = useState(InitIntl());
    const fetchIntel = useCallback((lng) => __awaiter(void 0, void 0, void 0, function* () { return setIntl(yield ReactIntl(lng || 'en', 'header')); }), []);
    const queryPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const profile = (user === null || user === void 0 ? void 0 : user.user_profile)
        ? user === null || user === void 0 ? void 0 : user.user_profile
        : 'https://assets.designs.ai/images/svg/icon-avatar.svg';
    const isVisitor = !isLogin && currentLanguage !== 'jp';
    const isFreeUser = isLogin &&
        currentLanguage !== 'jp' &&
        ((_a = user === null || user === void 0 ? void 0 : user.subscription) === null || _a === void 0 ? void 0 : _a.sub_category) === 'free' &&
        queryPath !== '/free-trial' &&
        ((_b = user === null || user === void 0 ? void 0 : user.trial) === null || _b === void 0 ? void 0 : _b.on_trial) === false;
    const isBasicUser = isLogin &&
        currentLanguage !== 'jp' &&
        ((_c = user === null || user === void 0 ? void 0 : user.subscription) === null || _c === void 0 ? void 0 : _c.sub_category) === 'basic' &&
        !queryPath.includes('/user/checkout') &&
        ((_d = user === null || user === void 0 ? void 0 : user.trial) === null || _d === void 0 ? void 0 : _d.on_trial) === false;
    // Display payment banner if user's subcsription has issue
    const hasPaymentIssue = (_e = user === null || user === void 0 ? void 0 : user.sub_on_hold) === null || _e === void 0 ? void 0 : _e.status;
    useEffect(() => {
        fetchIntel(currentLanguage);
    }, [currentLanguage]);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { style: customHeaderStyle, className: cx(classes.header, classes.sticky) },
            React.createElement(HeaderLogo, { classes: classes, isLogin: isLogin, Link: Link }),
            React.createElement(DesktopHeader, { user: user, Link: Link, intl: intl, profile: profile, isLogin: isLogin, onAction: onAction, isLoading: isLoading, changeLang: changeLang, proPlanId: proPlanId, queryPath: queryPath, clientName: clientName, additionalMenu: additionalMenu, currentLanguageLabel: currentLanguage, isCheckoutPage: currentRoute.includes('/user/checkout') }),
            React.createElement(MobileHeader, { Link: Link, intl: intl, user: user, isLogin: isLogin, profile: profile, onAction: onAction, queryPath: queryPath, changeLang: changeLang, proPlanId: proPlanId, additionalMenu: additionalMenu, currentLanguageLabel: currentLanguage, isCheckoutPage: currentRoute.includes('/user/checkout') })),
        React.createElement(ProPromoBanner, { user: user, intl: intl, isLogin: isLogin, currentRoute: currentRoute, onClickBanner: onClickBanner, currentLanguage: currentLanguage, accountCreatedDate: accountCreatedDate }),
        hasPaymentIssue && React.createElement(UpdatePaymentBanner, { intl: intl }),
        isVisitor || isFreeUser ? (React.createElement(Links, { Link: Link, to: '/free-trial', className: cx(classes.sticky, classes.sub_header), style: customLinkStyle }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'try_for_free',
            defaultMessage: 'Try for free'
        }))) : isBasicUser ? (React.createElement(Links, { Link: Link, to: '/user/checkout?q=' + proPlanId, className: cx(classes.sticky, classes.sub_header), style: customLinkStyle }, intl === null || intl === void 0 ? void 0 :
            intl.formatMessage({
                id: 'try_pro',
                defaultMessage: 'Try Pro'
            }),
            React.createElement("img", { src: 'https://assets.designs.ai/images/procrown.svg', width: '18px', height: '18px', alt: 'Designs.ai Pro crown' }))) : ('')));
};
//# sourceMappingURL=index.js.map